import {defineStore} from 'pinia'

export const useSlideOverStore = defineStore('slideOver', {

    state: () => ({
        isSlideOverOpen: false,
        title: '',
        description: '',
        component: '',
        context: null,
        size: 'md'
    }),

    actions: {
        setSlideOverOpen(isSlideOverOpen) {
            this.isSlideOverOpen = isSlideOverOpen
        },
        setTitle(title) {
            this.title = title
        },
        setDescription(description) {
            this.description = description
        },
        setComponent(component) {
            this.component = component
        },
        setContext(context) {
            this.context = context
        },
        setSize(size) {
            this.size = size
        },
        open({title, description = null, component, context = null, size = 'md'}) {
            this.title = title
            this.description = description
            this.component = component
            this.context = context
            this.size = size
            this.isSlideOverOpen = true
        },
        resetSlideOver() {
            this.isSlideOverOpen = false
            this.title = ''
            this.description = ''
            this.component = ''
            this.context = null
            this.size = 'lg'
        }
    }
})